import { useCallback } from "react";

import { LANGUAGE_NATIVE_LABELS } from "@/constants/common.constants";
import { Language } from "@/i18n/i18n.types";

export const useGetLanguageNativeLabel = () => {
  const getLanguageLabel = useCallback((language: Language) => {
    return LANGUAGE_NATIVE_LABELS[language];
  }, []);

  return getLanguageLabel;
};
